import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const saveUserRightsApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}user/save-rights`,
        method: "post",
        data: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })
    return response
}

export default saveUserRightsApi